import styles from "./modal.module.css";
import Modal from "@mui/material/Modal";
import PropTypes from "prop-types";

const ConfirmModal = (props) => {
  return (
    <Modal open={props.show} onClose={props.onClose}>
      <div className={styles.modalContainer}>
        <div className={styles.messageStyle}>{props.message}</div>
        <div
          style={{
            margin: "0,auto",
            display: "flex",
            justifyContent: "space-around",
          }}
        >
          <button className="submit" onClick={props.onSubmit}>
            {props.submit}
          </button>
          <button
            className="submit"
            onClick={props.onClose}
            style={{
              border: "1px solid #cb3366",
              background: "#fff",
              color: "#333333",
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </Modal>
  );
};

ConfirmModal.propTypes = {
  show: PropTypes.bool,
  message: PropTypes.string,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  submit: PropTypes.string,
};

export default ConfirmModal;
